module.exports = __webpack_public_path__ + "redhat-71669f86eb9733c4ac3e929b32194c93.svg";